// extracted by mini-css-extract-plugin
export var background = "_gg-6";
export var containerMedium = "_gg-0";
export var containerMicro = "_gg-2";
export var containerSmall = "_gg-1";
export var dropdown = "_gg-5";
export var dropdownLabel = "_gg-a";
export var enter = "_gg-7";
export var exitActive = "_gg-8";
export var label = "_gg-3";
export var option = "_gg-9";
export var select = "_gg-4";